import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H5 from '@base/H5/H5';
import Button from '@base/Button/Button';
import { Spacings } from '@styles/index';
import TextField from '@base/TextField/TextField';
import BottomSheet from '@comp/BottomSheet/BottomSheet';
import useInviteCode from './useInviteCode';

const StyledH5 = styled(H5)`
  text-align: center;
  margin-bottom: ${Spacings.SPACING_6B};
  padding: 0px ${Spacings.SPACING_11B};
`;

const Wrapper = styled.div``;

const StyledBtn = styled(Button)`
  margin-top: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  background-image: ${({ $isEnabled }) =>
    $isEnabled
      ? 'linear-gradient(180deg, var(--color-i-blue-4) 0%, var(--color-i-blue-3) 100%);'
      : 'none'};
`;

const InvitationCode = ({ enroll, onClose, show }) => {
  const {
    inviteCode,
    onInviteCodeChange,
    error,
    onEnroll,
    INVALID_INVITE_CODE,
    isEnrollButtonEnabled
  } = useInviteCode({ enroll });
  return (
    <BottomSheet open={show} onClose={onClose}>
      <StyledH5>You need an invite code to enroll in this contest</StyledH5>
      <Wrapper>
        <TextField
          fullWidth
          value={inviteCode}
          type="text"
          placeholder="Enter Invite code"
          onChange={onInviteCodeChange}
          error={error?.error_code === INVALID_INVITE_CODE.error_code}
          helperText={
            error?.error_code === INVALID_INVITE_CODE.error_code
              ? error?.message
              : ''
          }
          autoFocus
        />
        <StyledBtn
          grid={5}
          color="green"
          label="Enroll now"
          variant={isEnrollButtonEnabled ? 'filled' : 'disabled'}
          $isEnabled={isEnrollButtonEnabled}
          onClick={onEnroll}
        />
      </Wrapper>
    </BottomSheet>
  );
};

InvitationCode.propTypes = {
  enroll: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default InvitationCode;
